// Palette « 4 tons » par type de soin (prompt 14). Chaque ton = jeu de 4 valeurs
// d'une même teinte : bg (fond carte), border (bord 1px), ink (nom patient, très
// foncé), time (heure/durée, un cran plus clair). L'ordre est EXACT : il sert à
// l'attribution automatique. Seule la clé est stockée en base, jamais le hex.
export const CARE_TYPE_TONES = [
  { key: "vert", label: "Vert tendre", bg: "#eef6e9", border: "#c9e2bb", ink: "#1f3d31", time: "#2f5d4a" },
  { key: "sable", label: "Sable", bg: "#f7efe6", border: "#ead8c4", ink: "#5a3b2a", time: "#7a4e35" },
  { key: "bleu", label: "Bleu pâle", bg: "#e8f0fb", border: "#c7d8f2", ink: "#1e3a66", time: "#2b5596" },
  { key: "jaune", label: "Jaune pâle", bg: "#fdf6d8", border: "#f1e3a0", ink: "#5c4a07", time: "#7a6410" },
  { key: "rose", label: "Rose poudré", bg: "#fbeaee", border: "#f2cdd6", ink: "#6b2333", time: "#8f3a4d" },
  { key: "lavande", label: "Lavande", bg: "#f0ecfa", border: "#d9d0f0", ink: "#3d2e6b", time: "#5a4796" },
  { key: "menthe", label: "Menthe", bg: "#e6f5f2", border: "#bfe3db", ink: "#164a40", time: "#236b5c" },
  { key: "peche", label: "Pêche", bg: "#fdeee4", border: "#f5d3bd", ink: "#6b3a1c", time: "#8f5230" },
];

export const TONE_BY_KEY = Object.fromEntries(CARE_TYPE_TONES.map((t) => [t.key, t]));

// Hash stable d'un identifiant → index 0..7 (même type = toujours même ton).
function hashId(id) {
  let h = 0; const s = String(id || "");
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % CARE_TYPE_TONES.length;
}

// Ton d'un type de soin : sa clé si présente, sinon un ton stable issu de l'id.
export function toneForType(type) {
  if (!type) return CARE_TYPE_TONES[0];
  return TONE_BY_KEY[type.color_key] || CARE_TYPE_TONES[hashId(type.id)];
}

// Ton d'un RDV à partir de son type_soin (id) + liste des types. Défaut = vert.
export function toneForTypeId(typeId, careTypes) {
  const t = (careTypes || []).find((c) => c.id === typeId);
  return t ? toneForType(t) : CARE_TYPE_TONES[0];
}

// Premier ton libre (pour présélectionner la couleur à la création).
export function firstFreeToneKey(types) {
  const used = new Set((types || []).filter((t) => !t.archived && t.color_key).map((t) => t.color_key));
  for (const t of CARE_TYPE_TONES) if (!used.has(t.key)) return t.key;
  return CARE_TYPE_TONES[0].key;
}

// Clés déjà utilisées par d'autres types (pour le petit point « déjà pris »).
export function usedToneKeys(types, exceptId) {
  return new Set((types || []).filter((t) => t.id !== exceptId && !t.archived && t.color_key).map((t) => t.color_key));
}
